import { sendDelete, sendPostFormData } from '../hooks/use-fetch'

export async function UploadFile (file: File, folder: string = 'survey_uploads'): Promise<string> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('folder', folder)

  const { response, success } = await sendPostFormData('File/Upload', formData)
  if (!success) {
    throw new Error('Upload failed')
  }
  return response?.key
}

export async function DeleteFile (key: string): Promise<void> {
  const { success } = await sendDelete(`File/Delete?key=${encodeURIComponent(key)}`)
  if (!success) {
    throw new Error('Delete failed')
  }
}

export function GetDownloadUrl (key: string): string {
  return `${process.env.REACT_APP_API_URL ?? ''}/File/Download/${key}`
}
